/* eslint-disable jsx-a11y/label-has-associated-control */
import { Col, Row, Container } from "react-bootstrap";
import {
    StyledHourInput,
    StyledHourContainer,
    StyledInfoLabel,
} from "../../../styles/pages/CheckinParameters/CheckinParametersStyles";

interface ICheckinProps {
    qtdzeroadez: string;
    qtdezavinte: string;
    qtdvinteatrinta: string;
    qtdtrintaaquarenta: string;
    setQtdZeroADez: (value: string) => void;
    setQtdDezAVinte: (value: string) => void;
    setQtdVinteATrinta: (value: string) => void;
    setQtdTrintaAQuarenta: (value: string) => void;
}

const CheckinAbsences: React.FC<ICheckinProps> = ({
    qtdzeroadez,
    qtdezavinte,
    qtdvinteatrinta,
    qtdtrintaaquarenta,
    setQtdZeroADez,
    setQtdDezAVinte,
    setQtdVinteATrinta,
    setQtdTrintaAQuarenta,
}) => {
    const CheckAbsences = (absence: string) => {
        return !(
            Number(absence) < 0 ||
            Number(absence) > 99 ||
            !Number(absence + 1)
        );
    };
    return (
        <>
            <Container fluid style={StyledHourContainer}>
                <Row>
                    <Col>
                        <StyledInfoLabel>0 a 10 h/a</StyledInfoLabel>
                    </Col>
                </Row>
                <Row xs="auto">
                    <Col>
                        <div className="form-floating">
                            <StyledHourInput
                                type="number"
                                className="form-control"
                                id="Quantidade1"
                                placeholder="00:00"
                                min="0"
                                max="99"
                                value={qtdzeroadez}
                                onChange={(e) => setQtdZeroADez(e.target.value)}
                                onBlur={() =>
                                    CheckAbsences(qtdzeroadez)
                                        ? null
                                        : setQtdZeroADez("0")
                                }
                                required
                            />
                            <label htmlFor="Quantidade1">Quantidade</label>
                        </div>
                    </Col>
                </Row>
            </Container>

            <Container fluid style={StyledHourContainer}>
                <Row>
                    <Col>
                        <StyledInfoLabel>11 a 20 h/a</StyledInfoLabel>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <div className="form-floating">
                            <StyledHourInput
                                type="number"
                                className="form-control"
                                id="Quantidade2"
                                placeholder="00:00"
                                min="0"
                                max="99"
                                value={qtdezavinte}
                                onChange={(e) =>
                                    setQtdDezAVinte(e.target.value)
                                }
                                onBlur={() =>
                                    CheckAbsences(qtdezavinte)
                                        ? null
                                        : setQtdDezAVinte("0")
                                }
                                required
                            />
                            <label htmlFor="Quantidade2">Quantidade</label>
                        </div>
                    </Col>
                </Row>
            </Container>
            <Container fluid style={StyledHourContainer}>
                <Row>
                    <Col>
                        <StyledInfoLabel>21 a 30 h/a</StyledInfoLabel>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <div className="form-floating">
                            <StyledHourInput
                                type="number"
                                className="form-control"
                                id="Quantidade3"
                                placeholder="00:00"
                                min="0"
                                max="99"
                                value={qtdvinteatrinta}
                                onChange={(e) =>
                                    setQtdVinteATrinta(e.target.value)
                                }
                                onBlur={() =>
                                    CheckAbsences(qtdvinteatrinta)
                                        ? null
                                        : setQtdVinteATrinta("0")
                                }
                                required
                            />
                            <label htmlFor="Quantidade3">Quantidade</label>
                        </div>
                    </Col>
                </Row>
            </Container>
            <Container fluid style={StyledHourContainer}>
                <Row>
                    <Col>
                        <StyledInfoLabel>31 a 40 h/a</StyledInfoLabel>
                    </Col>
                </Row>
                <Row xs="auto">
                    <Col>
                        <div className="form-floating">
                            <StyledHourInput
                                type="number"
                                className="form-control"
                                id="Quantidade4"
                                placeholder="00"
                                min="0"
                                max="99"
                                value={qtdtrintaaquarenta}
                                onChange={(e) =>
                                    setQtdTrintaAQuarenta(e.target.value)
                                }
                                onBlur={() =>
                                    CheckAbsences(qtdtrintaaquarenta)
                                        ? null
                                        : setQtdTrintaAQuarenta("0")
                                }
                                required
                            />
                            <label htmlFor="Quantidade4">Quantidade</label>
                        </div>
                    </Col>
                </Row>
            </Container>
        </>
    );
};

export default CheckinAbsences;
